/*
*###############################################################################
*Module Name                   : VoucherTransferOut.js                         #
*Purpose of the Module         :                                               #
*Description of the Module     :                                               #
*Original Author               :  W M Shanika Chamodi                          #
*Date                          : Tuesday, January 4th 2022, 12:59:58 pm        #
*Copyright © 2022 myPOS Software Solution (pvt Ltd.)                           #
*###############################################################################
*/
import React, { useState, useEffect } from "react"
import { MetaTags } from "react-meta-tags"
import { Card, Col, Container, Row, CardBody, Alert } from "reactstrap"

//**Importing required componant files   */
import Breadcrumb from "components/Common/Breadcrumb"
import DPTopToolBar from "framework/widgets/DPTopToolBar"
import VoucherTransferOutContent from "./VoucherTransferOutContent"
import DPInfoBox from "framework/layout/DPInfoBox"
import { Text } from "../../../framework/validators/TextValidation"
import DPAlert from "../../../framework/widgets/DPAlert"
import DPLoadingAlert from 'framework/widgets/DPLoadingAlert'
import DPPermission from "framework/widgets/DPPermission"
import { setVoucherSave, getVoucherTROHeader, getVoucherREQHeader, CancelVoucher } from "./VoucherTransferOutController"
//*Detail content */
import VoucherTransferOutDetails from "./VoucherTransferOutDetails"
import { Context } from '../../../app-contexts/CommonContexts';
import { useHistory } from 'react-router-dom';
import { useContext } from "react"
import DPPrintOption from "framework/widgets/DPPrintOptions"
//**End Importing required componant files */

const detailObj = [{
  code: "",
  desc: "",
  VoucherFrom: "",
  VoucherTo: "",
  BookFrom: "",
  BookTo: "",
  id: 1
}]


const VoucherTransferOut = props => {
  //*** User input related states */
  let today = new Date()
  let date = today.toISOString().split("T")[0]

  let history = useHistory();
  const {
    getMenuDetails, masterAuditLog, addtoFavourite
  } = useContext(Context);

  const [strVoucherCode, SetCode] = useState("") // Set Code
  const [blVoucherCodeEnable, SetVoucherCodeEnable] = useState(false)
  const [strVoucherDate, SetVoucherDate] = useState(date) //Set DATE
  const [blVoucherDateEnable, SetVoucherDateEnable] = useState(false)
  const [strFromLocation, SetFromLocation] = useState("")
  const [blFromLocationEnable, SetFromLocationEnable] = useState(false)
  const [strToLocation, SetToLocation] = useState("")
  const [blToLocationEnable, SetToLocationEnable] = useState(false)
  const [strRemarks1, SetRemarks1] = useState("")
  const [blRemarks1Enable, SetRemarks1Enable] = useState(false)
  const [strRemarks2, SetRemarks2] = useState("")
  const [blRemarks2Enable, SetRemarks2Enable] = useState(false)


  const [blmainSearchEnable, SetmainSearchEnable] = useState(false)
  const [vouRequestDoc, setVouRequestDoc] = useState("")
  const [vouRequestDocDisable, setVouRequestDocDisable] = useState(false)

  const [addNew, SetAddNew] = useState(true)

  //*** End User input related states */

  //*** User Activity related states*/
  const [AlertMsg, setAlertMsg] = useState("")
  const [AlertColor, setAlertColor] = useState("")
  const [AlertShow, setAlertShow] = useState(false)
  const [ShowTaxTable, setShowTaxTable] = useState(false)
  const [blDiasableGrid, SetblDiasableGrid] = useState(false)

  const [modal_xlarge, setmodal_xlarge] = useState(false)
  const [model_xlarge_locTo, setmodel_xlarge_locTo] = useState(false)
  const [model_xlarge_locFrom, setmodel_xlarge_locFrom] = useState(false)
  const [modal_xlargeMain, setmodal_xlargeMain] = useState(false)
  const [model_xlarge_request, setmodel_xlarge_request] = useState(false)
  const [disabledDesc, setDisabledDesc] = useState(false)
  const [disabledCode, setDisabledCode] = useState(false)
  const [saveEnable, setSaveEnable] = useState(true)
  const [deleteEnable, setDeleteEnable] = useState(false)
  const [crEnable, setCrEnable] = useState(false)
  const [isCancelled, setIsCancelled] = useState(0)
  const [crBy, setCrBy] = useState("")
  const [mdBy, setMdBy] = useState("")
  const [crDate, setCrDate] = useState("")
  const [mdDate, setMdDate] = useState("")
  const [SupplierOpen, SetSupplieropen] = useState(false)
  const [menuCode, SetMenuCode] = useState("")

  //*** End User activity related staes */

  const [locationDescFrom, SetLocationDescFrom] = useState("")
  const [locationDescTo, SetLocationDescTo] = useState("")
  const [locationFromDisable, SetLocationFromDisable] = useState(false)
  const [locationToDisable, SetLocationToDisable] = useState(false)
  //*** useState to save table data */
  const [DataTables, SetDatatable] = useState([])
  const [DataTablesMain, SetDatatableMain] = useState([])

  const [strReason, setReason] = useState("Created")
  //*** End of useStates */

  const [disabled, setDisabled] = useState(false)
  const [detailRows, setDetailRows] = useState([{
    code: "",
    desc: "",
    VoucherFrom: "",
    VoucherTo: "",
    BookFrom: "",
    BookTo: "",
    requestQty: 0,
    id: 1,
    codeDisabled: false,
  }])

  const [refDetailRows, setRefDetailRows] = useState([])

  const [rowsTax, setrowsTax] = useState([])



  /**********Loading Alert */
  const [loadingAlert, SetLoadingAlert] = useState(false)
  const [loadingAlertTitle, SetLoadingAlerttitle] = useState("")
  /**********End Loading Alert */

  //User Permission related usestates
  const [permissionAlertShow, setPermissionAlertShow] = useState(false)
  const [permissionAlertTitle, setPermissionAlertTitle] = useState("")
  const [permissionReasonShow, setPermissionReasonShow] = useState(false)
  const [permissionName, setPermissionName] = useState("")
  const [permissionPassword, setPermissionPassword] = useState("")
  const [permissionNameDisable, setPermissionNameDisable] = useState(false)

  //*****Menu Rights Start*/
  const [menuAccess, SetMenuAccess] = useState(false)
  const [menuCreate, SetMenuCreate] = useState(false)
  const [menuDelete, SetMenuDelete] = useState(false)
  const [menuModify, SetMenuModify] = useState(false)
  const [menuPrint, SetMenuPrint] = useState(false)
  const [menuProcess, SetMenuProcess] = useState(false)
  const [menuName, SetMenuName] = useState("")
  const [parentName, SetParentName] = useState("")
  const [LocationCode, setLocationCode] = useState("")
  const [LogUserType, setLogUserType] = useState("")
  const [LogCompanyCode, setLogCompanyCode] = useState("")
  const [printEnable, setPrintEnable] = useState(false)
  const [printoptionShow, setprintoptionShow] = useState(false)

  const [currentPage, setCurrentPage] = useState(1)

  //*****Menu Rights End */
  const authToken = localStorage.getItem("authToken")
  const ApiURL = window.Links.ApiURL
  const [helpUrl, setHelpUrl] = useState("")
  var time = process.env.REACT_APP_ALERTTIMEOUT

  //**Get File Details */
  useEffect(async () => {
    var obj = JSON.parse(localStorage.getItem("authUser"))
    var LogUserType = obj[2]
    var menuDetail = await getMenuDetails(window.location.pathname)
    var menu = menuDetail && menuDetail.menuTag ? menuDetail.menuTag : history.push('/dashboard');
    var parentname = menuDetail?.parentName
    SetParentName(parentname)
    var LocationCode = obj[3]
    var CompanyCode = obj[5]
    setLocationCode(LocationCode)
    setLogUserType(LogUserType)
    setLogCompanyCode(CompanyCode)

    var requestOptions = {
      method: 'GET',
      headers: {
        "Authorization": `Bearer ${authToken}`
      },
      redirect: 'follow'
    };

    fetch(`${ApiURL}login/menu/${LogUserType}/${menu}`, requestOptions)
      .then(response => response.json())
      .then(result => {
        setPermissionReasonShow(result.data.strMenuReasonShow)
        SetMenuAccess(result.data.strMenuAccessRight)
        SetMenuCreate(result.data.strMenuCreateRight)
        SetMenuDelete(result.data.strMenuDeleteRight)
        SetMenuModify(result.data.strMenuModifyRight)
        SetMenuPrint(result.data.strMenuPrintRight)
        SetMenuProcess(result.data.strMenuProcessRight)
        SetMenuName(result.data.strMenuName)
        SetMenuCode(result.data.strMenuTag)
        setHelpUrl(result.data.strHelpUrl)
      }).catch(error =>
        console.log('error', error)
      );

  }, [])


  // AuditLog
  useEffect(async () => {
    var obj = JSON.parse(localStorage.getItem("authUser"))
    var LogUserType = obj[2]
    var LocationCode = obj[3]
    var CompanyCode = obj[5]
    var menuDetail = await getMenuDetails(window.location.pathname)
    var menu = menuDetail && menuDetail.menuTag ? menuDetail.menuTag : history.push("/dashboard")

    await masterAuditLog(menu, LogUserType, LocationCode, CompanyCode) //masterfile access log
  }, [])


  //Alert Parameter
  const [sweetAlertShow, setsweetAlertShow] = useState(false)
  const [AlertDescription, setAlertDescription] = useState(false)
  const [AlertConfirmOption, setAlertConfirmOption] = useState(0)

  function tog_xlarge() {
    setmodal_xlarge(!modal_xlarge)
    removeBodyCss()
  }

  function tog_xlargeMain() {
    setmodal_xlargeMain(!modal_xlargeMain)
    removeBodyCss()
  }

  function tox_xlarge_locTo() {
    setmodel_xlarge_locTo(!model_xlarge_locTo)
    removeBodyCss()
  }

  function tox_xlarge_locFrom() {
    setmodel_xlarge_locFrom(!model_xlarge_locFrom)
    removeBodyCss()
  }

  function tox_xlarge_request() {

    if (strFromLocation == "") {
      displayAlertMessage('danger', "Please Select a From Location")
      return
    }

    if (strToLocation == "") {
      displayAlertMessage('danger', "Please Select a To Location")
      return
    }

    setmodel_xlarge_request(!model_xlarge_request)
    removeBodyCss()
  }


  //removebodyCss function
  function removeBodyCss() {
    document.body.classList.add("no_padding")
  }

  //save button function
  const handlesave = async () => {
    // e.preventDefault()
    var VoucherPoDet = []


    detailRows.forEach((item, index) => {
      if (item.code != "" && item.BookFrom != "" && item.BookTo != "" && item.VoucherFrom != "" && item.VoucherTo != "") {
        VoucherPoDet.push(
          VoucherTROBuilder(
            item.code.toString(),
            item.BookFrom.toString(),
            item.BookTo.toString(),
            item.VoucherFrom.toString(),
            item.VoucherTo.toString(),
            item.requestQty
          )
        )
      }
    })

    if (strFromLocation == "") {
      displayAlertMessage('danger', "Please Select a From Location")
      return
    }
    if (strToLocation == "") {
      displayAlertMessage('danger', "Please Select a To Location")
      return
    }
    if (VoucherPoDet.length == 0) {
      displayAlertMessage('danger', "Need to assign at least one Voucher group !")
      return
    }

    //loading alert show
    SetLoadingAlert(true)
    if (addNew == true) {
      SetLoadingAlerttitle("Saving...")
    } else {
      SetLoadingAlerttitle("Updating...")
    }


    let strResult = await setVoucherSave(
      strVoucherCode,
      strVoucherDate,
      LocationCode,
      LogCompanyCode,
      strFromLocation,
      strToLocation,
      strRemarks1,
      strRemarks2,
      vouRequestDoc,
      LogUserType,
      menuCode,
      LogCompanyCode,
      LocationCode,
      strReason,
      VoucherPoDet
    )
    SetLoadingAlert(false)
    if (strResult.status == "200") {
      strResult.json().then(responseData => {

        if (responseData.data == "Record Already Exsist!") {
          displayAlertMessage('danger', responseData.data)
        } else if (responseData.data == "Code Already Exsist!") {
          displayAlertMessage('danger', responseData.data)
        } else {
          handleNew()
          displayAlertMessage('success', responseData.data)
        }
      })
    } else if (strResult.status == "400") {
      strResult.json().then(responseData => {
        setAlertMsg(responseData.msg)

      })
      setAlertColor("danger")
      //setAlertMsg("Oops something went wrong !")
      setAlertShow(true)
    } else {
      handleNew()
    }
    setTimeout(() => {
      setAlertShow(false)
    }, 6000)
  }

  //Voucher Po table Array
  const VoucherTROBuilder = (
    code,
    BookFrom,
    BookTo,
    VoucherFrom,
    VoucherTo,
    requestQty
  ) => {
    return {
      DET_TYPE: "VTO",
      DET_RUNNO: strVoucherCode.toString(),
      DET_SETUPLOC: LocationCode.toString(),
      DET_VCGROUP: code.toString(),
      DET_BOOKFROM: BookFrom.toString(),
      DET_BOOKTO: BookTo.toString(),
      DET_VOUCHERFROM: VoucherFrom.toString(),
      DET_VOUCHERTO: VoucherTo.toString(),
      DET_REQTY: parseFloat(requestQty)

    }
  }



  //*** Get user selected row details */

  const GetSelectRowMain = (e, row, isSelect, rowIndex) => {
    SetCode(row.HED_RUNNO)
    ValueSetterTO(row.HED_RUNNO)
    setmodal_xlargeMain(!modal_xlargeMain)

  }

  const GetSelectRowLocFrom = (e, row, isSelect, rowIndex) => {
    SetFromLocation(row.LOC_CODE)
    getLocation(row.LOC_CODE, 1)
    setmodel_xlarge_locFrom(!model_xlarge_locFrom)
  }

  const GetSelectRowLocTo = (e, row, isSelect, rowIndex) => {
    SetToLocation(row.LOC_CODE)
    getLocation(row.LOC_CODE, 2)
    setmodel_xlarge_locTo(!model_xlarge_locTo)

  }

  const GetSelectRowRequest = (e, row, isSelect, rowIndex) => {
    // SetToLocation(row.LOC_CODE)
    // getLocation(row.LOC_CODE, 2)
    setmodel_xlarge_request(!model_xlarge_request)
    getVoucherRequestData(row.HED_RUNNO)

  }


  //*** End of getSelectedRow function */

  //edit button function
  const handleEdit = e => {
    setDisabledDesc(false)
    setDisabledCode(true)
    setSaveEnable(true)
  }

  //new button function
  const handleNew = e => {
    ClearItem()
    setAlertMsg(false)
    setSaveEnable(true)
    setDeleteEnable(false)
  }

  //clear fields function
  const ClearItem = () => {
    let today = new Date()
    let date = today.toISOString().split("T")[0]
    SetCode("") // Set Code
    SetVoucherDate(date)
    SetFromLocation("")
    SetLocationDescFrom("")
    SetToLocation("")
    SetLocationDescTo("")
    SetRemarks1("")
    SetRemarks2("")


    SetmainSearchEnable(false)
    SetblDiasableGrid(false)
    setShowTaxTable(false)
    SetVoucherCodeEnable(false)
    SetVoucherDateEnable(false)
    SetFromLocationEnable(false)
    SetToLocationEnable(false)
    SetRemarks1Enable(false)
    SetRemarks2Enable(false)
    setSaveEnable(true)
    setDeleteEnable(false)
    setCrEnable(false)
    setIsCancelled(0)
    SetLocationFromDisable(false)
    SetLocationToDisable(false)
    setDisabled(false)
    setVouRequestDoc("")
    setVouRequestDocDisable(false)
    setDetailRows([{
      code: "",
      desc: "",
      VoucherFrom: "",
      VoucherTo: "",
      BookFrom: "",
      BookTo: "",
      requestQty: 0,
      id: 1,
      codeDisabled: false
    }])
    setRefDetailRows([])
    setCurrentPage(1)
    setPrintEnable(false)
  }


  // Set values to variables(Data Recall main method)
  const ValueSetterTO = async code => {

    if (code == "") return

    if (validateSpecialCharacters(code) == true) {
      SetCode("")
      return
    }

    SetLoadingAlert(true)
    SetLoadingAlerttitle("Fetching...")
    let { success, data } = await getVoucherTROHeader(code, LocationCode)
    SetLoadingAlert(false)

    if (success) {
      data.map(dr => {

        let modifiedRows = []

        setCrEnable(true)
        setSaveEnable(false)

        SetVoucherDate(dr.dtTxnDate)
        SetFromLocation(dr.strFromLocCode)
        SetToLocation(dr.strToLocCode)
        getLocation(dr.strFromLocCode, 1)
        getLocation(dr.strToLocCode, 2)
        SetRemarks1(dr.strRef1)
        SetRemarks2(dr.strRef2)
        setVouRequestDoc(dr.strRefNo)
        setCrBy(dr.createdBy)
        setCrDate(dr.createdDate)
        setIsCancelled(dr.isCancelled)
        if (dr.isCancelled == 1) {
          setDeleteEnable(false)
        } else {
          setDeleteEnable(true)
        }

        SetmainSearchEnable(true)
        SetblDiasableGrid(true)
        SetVoucherCodeEnable(true)
        SetVoucherDateEnable(true)
        SetFromLocationEnable(true)
        SetToLocationEnable(true)
        SetRemarks1Enable(true)
        SetRemarks2Enable(true)


        setDisabled(true)
        dr.vctrodetails.map(dr => {
          modifiedRows.push({
            id: modifiedRows.length + 1,
            code: dr.deT_VCCAT,
            desc: dr.deT_VCCATNAME,
            VoucherFrom: dr.deT_VOUCHERFROM,
            VoucherTo: dr.deT_VOUCHERTO,
            BookFrom: dr.deT_BOOKFROM,
            BookTo: dr.deT_BOOKTO,
            requestQty: dr.deT_REQQTY,
            codeDisabled: false
          })
        })
        setDetailRows(modifiedRows)
        setPrintEnable(true)
      })
    } else {
      displayAlertMessage('success', 'Record Not Found !')
    }
  }


  async function getVoucherRequestData(voucherCode) {


    if (strFromLocation == "") {
      displayAlertMessage('danger', "Please Select a From Location")
      return false
    }

    if (strToLocation == "") {
      displayAlertMessage('danger', "Please Select a To Location")
      return false
    }

    SetLoadingAlert(true)
    SetLoadingAlerttitle("Fetching...")
    const { success, data } = await getVoucherREQHeader(voucherCode, strToLocation)
    SetLoadingAlert(false)

    if (success) {

      var modifiedRows = []

      data.vcpodetails.map((item, index) => {
        modifiedRows.push({
          code: item.deT_VCCAT,
          desc: item.deT_VCCATNAME,
          VoucherFrom: "",
          VoucherTo: "",
          BookFrom: "",
          BookTo: "",
          requestQty: item.deT_VCBQTY,
          id: index + 1,
          codeDisabled: true,
        })
      })
      setDetailRows(modifiedRows)
      setRefDetailRows([...modifiedRows])
      setVouRequestDoc(voucherCode)
      setVouRequestDocDisable(true)

    } else {
      setVouRequestDoc("")
      displayAlertMessage('danger', "Voucher Request Not Found")
    }


    return true
  }



  //modal props
  const columnsMain = [
    {
      dataField: "id",
      text: "Id",
      sort: true,
    },
    {
      dataField: "code",
      text: "Code",
      sort: true,
    },
    {
      dataField: "strFromLocCode",
      text: "From Location",
      sort: true,
    },
    {
      dataField: "strToLocCode",
      text: "To Location",
      sort: true,
    },

    {
      dataField: "crby",
      text: "Created by",
      sort: true,
    },
    {
      dataField: "crdate",
      text: "Created on",
      sort: true,
    },

  ]
  //default sorted method
  const defaultSorted = [
    {
      dataField: "id",
      order: "asc",
    },
  ]
  //default sorted method
  const defaultSortedMain = [
    {
      dataField: "id",
      order: "asc",
    },
  ]


  const handleDelete = async () => {

    const JsonBody = {
      "voucehrCode": strVoucherCode,
      "location": LocationCode,
      "user": LogUserType
    }

    SetLoadingAlert(true)
    SetLoadingAlerttitle("Canceling...")

    try {
      const { isSuccessful, message } = await CancelVoucher(JsonBody)

      if (isSuccessful) {
        displayAlertMessage('success', message)
        ClearItem()
      }
      else {
        displayAlertMessage('danger', message)
      }

    } catch (error) {
      console.log(error)
    } finally {
      SetLoadingAlert(false)
    }

  };


  //**Permission Check */
  const permission = (operation) => {
    const ApiURL = window.Links.ApiURL
    const authToken = localStorage.getItem("authToken")
    const permissiondata = {
      "strUsername": permissionName,
      "strPassword": permissionPassword,
      "strLocation": LocationCode,
      "strMenuCode": menuCode
    }

    clearPermissionInputs()

    fetch(`${ApiURL}login/userpermission`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${authToken}`
        },
        body: JSON.stringify(permissiondata)
      }
    ).then(Response => {
      if (Response.status == "200") {
        Response.json()
          .then(responseData => {
            let Access = (responseData.data.strMenuAccessRight)
            let Create = (responseData.data.strMenuCreateRight)
            let Delete = (responseData.data.strMenuDeleteRight)
            let Modify = (responseData.data.strMenuModifyRight)
            let Print = (responseData.data.strMenuPrintRight)
            let Process = (responseData.data.strMenuProcessRight)

            if (operation == "Save") {
              if (Create == true) {
                handlesave()
              } else if (Modify == true) {
                handlesave()
              } else {
                if (operation == "Save" && addNew == true) {
                  displayAlertMessage('danger', "This user dosen't have permission to save")
                } else {
                  displayAlertMessage('danger', "This user dosen't have permission to edit")
                }
              }
            } else if (operation == "Delete") {
              if (Delete == true) {
                handleDelete()
              } else {
                displayAlertMessage('danger', "This user don't have permission to delete !")
              }
            } else if (operation == "Print") {
              if (Print == true) {
                setprintoptionShow(true)
              } else {
                displayAlertMessage('danger', "This user don't have permission to print !")
              }
            }
          }
          )

      } else if (Response.status == "400") {
        setDisabled(false)
        setDisabledCode(false)
        displayAlertMessage('danger', "Oops something went wrong !")
        clearPermissionInputs()

      } else if (Response.status == "403") {
        setDisabled(false)
        setDisabledCode(false)
        displayAlertMessage('danger', "You have not Permission to make changes !")
        clearPermissionInputs()

      } else if (Response.status == "404") {
        setDisabled(false)
        setDisabledCode(false)
        displayAlertMessage('danger', "Password or User Name is Invalid !")
        clearPermissionInputs()

      } else {
        ClearItem()
      }
    }).catch(error => {
      console.log(error.message)
    })
  }

  function getLocation(locCode, search) {
    if (locCode == "" || locCode == undefined) {

      if (search === 1) {
        SetFromLocation("")
        SetLocationDescFrom("")
        SetLocationFromDisable(false)
      } else {
        SetToLocation("")
        SetLocationDescTo("")
        SetLocationToDisable(false)
      }
    }
    var requestOptions = {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${authToken}`
      },
      redirect: 'follow'
    };
    fetch(`${ApiURL}Locations/SearchCode/${locCode}`, requestOptions)
      .then(response => response.json())
      .then(result => {
        const dt = result.data[0];
        if (result.success == true) {
          if (search === 1) {
            SetLocationDescFrom(dt.name)
            SetLocationFromDisable(true)
          } else {
            SetLocationDescTo(dt.name)
            SetLocationToDisable(true)
          }
        }
        else {
          if (search === 1) {
            SetFromLocation("")
            SetLocationDescFrom("")
          } else {
            SetToLocation("")
            SetLocationDescTo("")
          }
          displayAlertMessage('danger', "Invalid Location Code")
          return
        }
      })
      .catch(error => console.log('error', error));
  }

  //Function for display Alert Messages
  function displayAlertMessage(color, message) {
    setAlertColor(color)
    setAlertMsg(message)
    setAlertShow(true)

    setTimeout(() => {
      setAlertShow(false)
    }, time)
  }


  //handle permission alert
  function handlePermissionAlert(LogUserType, reason, disable, alertShow) {
    setPermissionName(LogUserType)
    setReason(reason)
    setPermissionNameDisable(disable)
    setPermissionAlertShow(alertShow)
  }


  //Clear permission name & password
  function clearPermissionInputs() {
    setPermissionName("");
    setPermissionPassword("");
    setReason("");
  }

  //Handle Favourite Button
  const handleFavourite = async () => {
    var response = await addtoFavourite(menuCode, LogUserType);
    console.log(response)
  }


  const validateSpecialCharacters = (str) => {
    const specialCharRegex = /[!@#$%^&*(),.?":{}|<>]/;
    return specialCharRegex.test(str);
  };


  async function handlePrint(option) {
    var option = option
    const authToken = localStorage.getItem("authToken")

    SetLoadingAlert(true)
    SetLoadingAlerttitle("Generating Report...")


    const ReportURL = window.Links.ReportURL
    await fetch(`${ReportURL}api/VoucherTRO/report/${LogUserType}/${strVoucherCode}/${LocationCode}/${option == "PDF" ? 1 : 0}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${authToken}`
      }
    }).then(Response => Response.json())
      .then(responseData => {
        if (responseData.success == true) {
          if (option == "PDF") {

            const msg = responseData.msg
            window.open(`${ReportURL}temp_print/${msg.replace("\r\n", '')}.pdf`)

          } else if (option == "XCEL") {

            const msg = responseData.msg
            window.open(`${ReportURL}temp_print/${msg.replace("\r\n", '')}.xls`)

          }

        }
        SetLoadingAlert(false)
      }).catch(error => {
        console.log(error.message)
      })
  }


  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Voucher Transfer Out Note</title>
        </MetaTags>
        <Container fluid={true}>
          <Breadcrumb
            title={parentName}
            breadcrumbItem="Voucher Transfer Out Note"
          ></Breadcrumb>
          <DPAlert
            confirm_both={sweetAlertShow}
            title={"Voucher Transfer Out Note!"}
            description={AlertDescription}
            showCancel={true}
            btnColor={"success"}
            cancelColor={"danger"}
            onConfirm={() => {
              setsweetAlertShow(false)
              if (AlertConfirmOption == 1) {
                //  alert(permissionReasonShow)
                if (addNew == true && menuCreate == true && permissionReasonShow == false) {
                  handlesave()
                } else if (addNew == true && menuCreate == true && permissionReasonShow == true) {
                  handlePermissionAlert(LogUserType, "Created", true, true)
                } else if (addNew == false && menuModify == true && permissionReasonShow == false) {
                  handlesave()
                } else if (addNew == false && menuModify == true && permissionReasonShow == true) {
                  handlePermissionAlert(LogUserType, "Updated", true, true)
                } else {
                  setPermissionReasonShow(true)
                  setPermissionAlertShow(true)
                }

              } else if (AlertConfirmOption == 2) {
                handleEdit()
              } else if (AlertConfirmOption == 3) {
                window.location.href = "/";
              } else if (AlertConfirmOption == 4) {
                handleNew()
              } else if (AlertConfirmOption == 5) {

                if (addNew == false && menuDelete == true && permissionReasonShow == false) {
                  handleDelete()
                } else if (addNew == false && menuDelete == true && permissionReasonShow == true) {
                  handlePermissionAlert(LogUserType, "Deleted", true, true)
                } else {
                  setPermissionReasonShow(true)
                  setPermissionAlertShow(true)
                }
              } else if (AlertConfirmOption == 6) {
                if (menuPrint == true && permissionReasonShow == false) {
                  setprintoptionShow(true)
                } else if (menuPrint == true && permissionReasonShow == true) {
                  handlePermissionAlert(LogUserType, "Printed", true, true)
                } else {
                  setPermissionName("")
                  setPermissionNameDisable(false)
                  setPermissionAlertShow(true)
                }
              }

            }}
            onCancel={() => {
              setsweetAlertShow(false)
              clearPermissionInputs()
            }}
            SupplierOpen={SupplierOpen}
            SetSupplieropen={() => {
              SetSupplieropen(!SupplierOpen)
            }}
          />
          <DPPrintOption
            confirm_both={printoptionShow}
            title={menuName}
            showCancel={true}
            cancelColor={"danger"}
            onConfirmpdf={() => {
              handlePrint("PDF")
              setprintoptionShow(false)
            }}
            onConfirmxcel={() => {
              handlePrint("XCEL")
              setprintoptionShow(false)
            }}
            onCancel={() => {
              setprintoptionShow(false)
            }}
          />
          <DPPermission
            confirm_both={permissionAlertShow}
            title={menuName}
            description={permissionAlertTitle}
            showReason={permissionReasonShow}
            nameDisable={permissionNameDisable}
            showCancel={true}
            btnColor={"success"}
            cancelColor={"danger"}
            AlName={permissionName}
            AlNameOnchange={e => {
              let val2 = Text(e.target, 50, true, false, "any", true)
              setPermissionName(val2)
            }}
            AlPassward={permissionPassword}
            AlPasswardOnchange={e => {
              let val2 = Text(e.target, 50, true, true, "any", true)
              setPermissionPassword(val2)
            }}
            AlReason={strReason}
            AlReasonOnchange={e => {
              let val2 = Text(e.target, 50, true, false, "any", true)
              setReason(val2)
            }}
            onConfirm={() => {
              setPermissionAlertShow(false)
              if (AlertConfirmOption == 1) {
                permission("Save")
              } else if (AlertConfirmOption == 5) {
                permission("Delete")
              } else if (AlertConfirmOption == 7) {
                permission("Delete")
              } else if (AlertConfirmOption == 6) {
                permission("Print")
                // setprintoptionShow(true)
              }
            }}
            onCancel={() => {
              setPermissionAlertShow(false)
              clearPermissionInputs()
            }}
          />
          <DPLoadingAlert
            confirm_both={loadingAlert}
            title={loadingAlertTitle}
          />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <DPTopToolBar
                    //Help Button
                    helpEnable={helpUrl != "" ? true : false}
                    helpClick={() => {
                      window.open(helpUrl)
                    }}
                    //Favorite Button
                    favoriteEnable={true}
                    favoriteClick={handleFavourite}
                    //New Button
                    newEnable={true}
                    newClick={() => {
                      setAlertDescription("Do you wish to refresh the screen ?")
                      setAlertConfirmOption(4)
                      setsweetAlertShow(true)
                    }}
                    //Save Button
                    saveEnable={saveEnable}
                    saveClick={() => {
                      setAlertDescription("Do you wish to save ?")
                      setAlertConfirmOption(1)
                      setsweetAlertShow(true)
                    }}
                    //ProcessButton
                    processEnable={false}
                    processClick={() => {
                      alert("Process")
                    }}
                    //Edit Button
                    editEnable={false}
                    editClick={() => {
                      setAlertDescription("Do you wish to edit ?")
                      setAlertConfirmOption(2)
                      setsweetAlertShow(true)
                    }}
                    //Print Button
                    printEnable={printEnable}
                    printClick={() => {
                      setReason("Printed")
                      setAlertDescription("Do you wish to print ?");
                      setAlertConfirmOption(6)
                      setsweetAlertShow(true)
                    }}
                    //Delete Button
                    deleteEnable={deleteEnable}
                    deleteClick={() => {
                      setAlertDescription("Do you wish to Cancel This Document ?")
                      setAlertConfirmOption(5)
                      setsweetAlertShow(true)
                    }}
                    //Exit Button
                    exitEnable={true}
                    exitClick={() => {
                      setAlertDescription("Do you wish to exit ?")
                      setAlertConfirmOption(3)
                      setsweetAlertShow(true)
                    }}
                  />
                  <Row>
                    {isCancelled == 1 ? (
                      <Alert color={'danger'} role="alert">
                        Cancelled Document
                      </Alert>
                    ) : null}
                  </Row>
                  <Row>
                    <VoucherTransferOutContent
                      Gen_DataSearch={async () => {
                        // let data = await getVoucherTROSearch(LocationCode)

                        // let i = 1
                        // data.map(r => {
                        //   searchDataMain = searchDataMain.concat(
                        //     TableDataBuilderMain(i, r)
                        //   )
                        //   i++
                        // })
                        // console.log(searchDataMain)
                        // SetDatatableMain(searchDataMain)
                        tog_xlargeMain()
                      }}
                      DataTablesMain={DataTablesMain}
                      Hed_CodeSearchOpenMain={modal_xlargeMain}
                      Hed_CodeSearchTriggerMain={tog_xlargeMain}
                      SearchDataTablesMain={DataTablesMain}
                      SearchColumnsMain={columnsMain}
                      SearchDefaultSortedMain={defaultSortedMain}
                      SearchModelOpenMain={modal_xlargeMain}
                      SearchModelTriggerMain={tog_xlargeMain}
                      SearchGetSelectRowMain={GetSelectRowMain}

                      DataTables={DataTables}
                      Hed_CodeSearchOpen={modal_xlarge}
                      Hed_CodeSearchTrigger={tog_xlarge}
                      AlertColor={AlertColor}
                      AlertMsg={AlertMsg}
                      show={AlertShow}
                      Gen_Code={strVoucherCode}
                      Gen_Code_OnChange={e => {
                        let valCode = Text(
                          e.target,
                          13,
                          true,
                          false,
                          "upper",
                          false
                        )
                        SetCode(valCode)
                      }}
                      Gen_Code_onBlur={e => {
                        ValueSetterTO(e.target.value)
                      }}
                      Gen_Code_Enabled={blVoucherCodeEnable}

                      Gen_FromLocation={strFromLocation}

                      Gen_FromLocation_Enabled={blFromLocationEnable}
                      Gen_ToLocation={strToLocation}

                      Gen_ToLocation_Enabled={blFromLocationEnable}
                      Gen_TxnDate={strVoucherDate}
                      Gen_TxnDate_OnChange={e => {
                        SetVoucherDate(e.target.value)
                      }}
                      Gen_TxnDate_Enabled={blVoucherDateEnable}
                      Gen_Remark1={strRemarks1}
                      Gen_Remark1_OnChange={e => {
                        let valCode = Text(
                          e.target,
                          50,
                          true,
                          false,
                          "any",
                          true
                        )
                        SetRemarks1(valCode)
                      }}


                      Gen_Remark1_Enabled={blRemarks1Enable}
                      Gen_Remark2={strRemarks2}
                      Gen_Remark2_OnChange={e => {
                        let valCode = Text(
                          e.target,
                          50,
                          true,
                          false,
                          "any",
                          true
                        )
                        SetRemarks2(valCode)
                      }}
                      Gen_Remark2_Enabled={blRemarks2Enable}
                      SearchDataTables={DataTables}

                      SearchDefaultSorted={defaultSorted}
                      SearchModelOpen={modal_xlarge}
                      SearchModelTrigger={tog_xlarge}
                      Gen_mainSearchEnabled={blmainSearchEnable}
                      menuCode={menuCode}
                      LocationCode={LocationCode}
                      locationDescTo={locationDescTo}
                      locationDescFrom={locationDescFrom}
                      locationOnblurTo={e => {
                        getLocation(e.target.value, 2)
                      }}
                      locationOnblurFrom={e => {
                        getLocation(e.target.value, 1)
                      }}
                      tox_xlarge_locTo={tox_xlarge_locTo}
                      tox_xlarge_locFrom={tox_xlarge_locFrom}
                      tox_xlarge_request={tox_xlarge_request}
                      model_xlarge_request={model_xlarge_request}
                      model_xlarge_locFrom={model_xlarge_locFrom}
                      model_xlarge_locTo={model_xlarge_locTo}
                      Gen_FromLocation_OnChange={e => {
                        let val1 = Text(
                          e.target,
                          5,
                          true,
                          false,
                          "upper",
                          false
                        )
                        SetFromLocation(val1)
                      }}
                      Gen_ToLocation_OnChange={e => {

                        let val1 = Text(
                          e.target,
                          10,
                          true,
                          false,
                          "upper",
                          false
                        )
                        SetToLocation(val1)
                      }}
                      GetSelectRowlOCTo={GetSelectRowLocTo}
                      GetSelectRowLocFrom={GetSelectRowLocFrom}
                      GetSelectRowRequest={GetSelectRowRequest}
                      locationFromDisable={locationFromDisable}
                      locationToDisable={locationToDisable}
                      vouRequestDoc={vouRequestDoc}
                      vouRequestDocOnchange={e => {
                        setVouRequestDoc(e.target.value)
                      }}
                      vouRequestDocOnblur={async (e) => {
                        var result = await getVoucherRequestData(e.target.value)
                        if (!result) {
                          setVouRequestDoc("")
                        }
                      }}
                      vouRequestDocDisable={vouRequestDocDisable}
                      disabled={disabled}
                    />
                  </Row>
                  <Row>
                    <VoucherTransferOutDetails
                      DataRow={detailRows}
                      setDetailRows={setDetailRows}

                      Disabled={disabled}
                      rowsTax={rowsTax}
                      ShowTaxTable={ShowTaxTable}
                      blDiasableGrid={blDiasableGrid}
                      strFromLocation={strFromLocation}
                      menuCode={menuCode}
                      LocationCode={LocationCode}
                      refDetailRows={refDetailRows}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </Row>

                  <Row>
                    {crEnable ? (
                      <DPInfoBox
                        createdBy={crBy}
                        createdOn={crDate}
                        modifiedBy={mdBy}
                        modifiedOn={mdDate}
                      />
                    ) : null}
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default VoucherTransferOut